import React from 'react';

import { observer } from 'mobx-react';

import classes from './NgzAutomatedBillingPaymentTab.module.scss';
import { EntityType } from '../../../../shared/constants/user-info/ENTITY_TYPES';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { FeeModuleWidget } from '../../../containers/FeeModuleWidget/FeeModuleWidget';
import { TaxWidget } from '../../../containers/TaxWidget/TaxWidget';
import { SubscriptionSettingsWidget } from '../../../containers/SubscriptionSettingsWidget/SubscriptionSettingsWidget';
import { NutritionSubscriptionsManagement } from '../../../containers/EntitySubscriptionsManagement/NutritionSubscriptionsManagement/NutritionSubscriptionsManagement';
import { FreeAccessWidget } from '../../../containers/FreeAccessWidget/FreeAccessWidget';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { CoachSeatsWidget } from '../../../containers/CoachSeatsWidget/CoachSeatsWidget';
import { useCoachSeats } from '../../../hooks/useCoachSeats';

type NgzAutomatedBillingPaymentTabProps = {
  entityId: number;
  isStripeConnected: boolean;
  entityType: EntityType;
};

const NgzAutomatedBillingPaymentTab = observer(
  ({ entityId, isStripeConnected, entityType }: NgzAutomatedBillingPaymentTabProps) => {
    const { isEntity, isSuperAdmin } = loggedInUserDataStore;

    const { coachSeats } = useCoachSeats(entityId);

    return (
      <>
        <div className={classes.row}>
          <div className={classes.column}>
            {isEntity && (
              <ConnectStripeWidget
                entityId={entityId}
                isStripeConnected={isStripeConnected}
              />
            )}
            {isSuperAdmin && (
              <FeeModuleWidget entityId={entityId} entityType={entityType} />
            )}
            <TaxWidget entityId={entityId} />
          </div>
          <SubscriptionSettingsWidget entityId={entityId} />
        </div>
        <CoachSeatsWidget
          entityId={entityId}
          isCoachSeatsCreated={!!coachSeats}
          defaultMode="VIEW"
          coachSeats={coachSeats}
          showAddSeatsButton
        />
        <NutritionSubscriptionsManagement entityId={entityId} />
        <FreeAccessWidget entityId={entityId} />
      </>
    );
  },
);

angularizeWithProviders(NgzAutomatedBillingPaymentTab, 'ngzAutomatedBillingPaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
  entityType: '<',
});
